import { useSnackbar } from 'notistack';
import { useMutation, useQueryClient } from 'react-query';
import { useService } from 'shared/providers';
import { Quote } from 'shared/types';

export function useUpdateQuote(isQuoteReminderUpdate?: boolean) {
  const { quoteService } = useService();
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const mutation = useMutation<{ operationId: string }, Error, Quote>(request => quoteService.updateQuote(request), {
    onSuccess: data => {
      enqueueSnackbar(`Quote${isQuoteReminderUpdate ? ' reminder' : ''} was updated`, { variant: 'success' });
      queryClient.invalidateQueries('quote');
      queryClient.invalidateQueries('quote-reminders');
    },
    onError: () => {
      enqueueSnackbar('Quote was not updated', { variant: 'error' });
    },
  });

  return mutation;
}
